<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            提醒记录
        </div>
        <div style="padding: 20px;">
            <div class="top">
                <el-row>
                    <div style="float:right">
                        <!-- <span class="demonstration">所属区域：</span>
                        <elSelectTree :options='zoneValue' accordion :props="zoneProps" placeholder="请选择所属区域" v-on:getZoneValue="getZoneValue" style="width:250px;margin-right:20px"></elSelectTree> -->
                        <span class="demonstration">起止时间：</span>
                        <el-date-picker
                            ref="picker"
                            v-model="datetimerangeValue"
                            type="daterange"
                            :clearable='false'
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width:250px;margin-right:20px">
                        </el-date-picker>
                        <el-button type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>
                    </div>
                </el-row>

                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" :height="th" border style="width: 100%;">
                        <el-table-column prop="elderly.name" label="老人名称" width="100"></el-table-column>
                        <el-table-column prop="elderly.phone" label="手机号" width="120"></el-table-column>
                        <el-table-column prop="elderly.zoneName" label="所属区域" width="300"></el-table-column>
                        <el-table-column
                                prop="remindType"
                                :formatter="statusTitle"
                                label="类型" width="130">
                        </el-table-column>
                        <el-table-column prop="remarks" label="内容" ></el-table-column>
                        <el-table-column
                                prop="status"
                                :formatter="genderTitle"
                                label="类型" width="130">
                        </el-table-column>
                        <el-table-column prop="createTime" :formatter="timefilter" width="200" label="创建时间"></el-table-column>
                    </el-table>
                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    :current-page.sync="currentPage"  @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>

        <!-- <Add ref="myAdd" v-show="showModalAdd" v-bind:areaValue="areaValue" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit"  v-bind:areaValue="areaValue"  v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit> -->

    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    // import Edit from "./Edit";
    // import Add from "./Add";
    // import elSelectTree from "../../../components/ElSelectTree"
    import {getStaffCode} from "@/utils/auth";
    export default {
        name: "Role",
        data(){
            return{
                loading:false,
                showModalAdd:false,
                showModalEdit:false,
                datetimerangeValue:'',
                tableData:null,
                zoneValue:[],
                idNumber:'',
                zoneCode:'',
                phone:'',
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                name:'',
                zoneProps:{
                    emitPath:false,
                    value: 'zoneCode',
                    // 显示的文字字段名
                    label: 'name',
                    // 子层级字段名
                    children: 'listZoneDTO'
                },
            }
        },
        // components:{
        //     elSelectTree
        // },
        created(){
            this.init();
            this.getList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            init(){
                const end = new Date();
                const start=new Date(end - 1000 * 60 * 60 * 24 * 365);
                this.datetimerangeValue=[start, end];
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Zone/ListForStaff",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then( (response)=> {
                    console.log(response);
                    if(response.data.error == 0){
                        var data=JSON.stringify(response.data.data);
                        data=JSON.parse(data.replace(/"listZoneDTO":\[\],/g,''))
                        this.zoneValue = data;
                    }else if(response.data.error == 1){
                        this.$message.error(response.data.message)
                    }
                })
            },
            timefilter(row, column, cellValue){
                return timefilters(cellValue)
            },
            handleEdit(index, row) {
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            searchGetList(){
                this.getList();
            },
            getZoneValue(val){
                this.zoneCode=val
            },
            statusTitle(row, column, cellValue){
                if(cellValue==1){
                    return  '高龄老人未打卡提醒'
                }else{
                    return  '订单已完成提醒'
                }
                 
            },
            getList(isSearch){
                if(isSearch)this.currentPage=1
                // var zoneCode='00000000-0000-0000-0000-000000000000'
                // if(this.zoneCode){
                //     zoneCode=this.zoneCode
                // }
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Remind/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                        startTime:timefilters(this.datetimerangeValue[0]),
                        endTime:timefilters(this.datetimerangeValue[1]),
                        // zoneCode:zoneCode
                    }
                }).then( (response)=> {
                    console.log(response);
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            applyTypeTitle(row){
                if(row.applyType == 0){
                    return "80-99周岁";
                }
                if(row.applyType == 1){
                    return "100周岁及以上";
                }
            },
            genderTitle(row, column, cellValue){
                if(cellValue == 0){
                    return "未读";
                }
                if(cellValue == 1){
                    return "已读";
                }
            },



        }
    }
</script>

<style scoped>

</style>
